//** Returns the Local Details External Table Name. Appends a local_details_ before the local_details_type_id */
export const localDetailsExternalTable = (local_details_id) => `local_details_${local_details_id}`;

/** Decides if the Local Details Type is unremovable or not. The list is static inside the function definition. */
export const isRemovableLocalDetailsType = ({local_details_type_name}) => {
  const permList = ['Hotel', 'Restaurant'];
  return !permList.includes(local_details_type_name);
}
